import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux'; 
import { thunk } from 'redux-thunk';
import allReducers from './store/reducers';
import App from './App';


// Azure
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "../src/config/msalConfig";

const store = createStore(allReducers,applyMiddleware(thunk));

// Azure
const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <App/>
        </MsalProvider>
      </BrowserRouter>
    </Provider>,
  document.getElementById('root')
);
